export default __webpack_public_path__ + "static/media/HERO_Roomboard_desktop.abe08230.jpg";